import React, { forwardRef, Ref } from 'react';

import Link from '../../components/Link/Link.jsx';
import Popover from '../../components/Popover/Popover.jsx';

interface Props {
  children?: React.ReactNode;
}

const BreadcrumbExpander = ({ children }: Props, ref: Ref<HTMLDivElement>) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLAnchorElement | null>(
    null,
  );

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div ref={ref}>
      <Link onClick={handleClick}>. . .</Link>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {children}
      </Popover>
    </div>
  );
};

export default forwardRef<HTMLDivElement, Props>(BreadcrumbExpander);
